<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <!-- <vuexy-logo />

        <h2 class="brand-text text-primary ml-1">
          Vuexy
        </h2> -->
      </b-link>
      <!-- /Brand logo-->

      <!-- Register-->
      <b-col lg="6" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto" v-if="register_available == 1 ||  register_type == 2">
          <h3 class="text-dark font-weight-bolder"> انشاء حساب جديد{{register_available == 2 ? '  بالمقرأة الإلكترونية' : ''}}</h3>

          <!-- انشاء حساب علي المنصة / انشاء حساب علي مقراة-->
          <!-- <b-row class="mt-2" v-if="link != 'quran'">
            <b-col md="6" class="mb-1">
              <b-form-group id="input-group-29" label-for="input-29">
                <b-form-radio v-model="register_type" name="acc_type" value="1">
                  انشاء حساب علي المنصة
                </b-form-radio>
                <b-form-radio v-model="register_type" name="acc_type" value="2">
                  انشاء حساب علي مقراة
                </b-form-radio>
              </b-form-group>
            </b-col>
          </b-row> -->
          <!-- form -->
          <validation-observer ref="registerForm" #default="{ invalid }">
            <b-form class="auth-register-form mt-2" @submit.prevent="register">
              <b-row>
                <b-col md="6" class="mb-1">
                  <!-- .first_name -->
                  <b-form-group id="input-group-27" :label="$t('students.first_name')" label-for="input-27">
                    <validation-provider #default="{ errors }" name="first_name" vid="first_name" rules="required">
                      <b-form-input id="input-27" v-model="newItem.first_name" type="text"
                        :placeholder="$t('students.first_name')">
                      </b-form-input>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6" class="mb-1">
                  <!-- .last_name -->
                  <b-form-group id="input-group-28" :label="$t('students.last_name')" label-for="input-28">
                    <validation-provider #default="{ errors }" name="last_name" vid="last_name" rules="required">
                      <b-form-input id="input-28" v-model="newItem.last_name" type="text"
                        :placeholder="$t('students.last_name')">
                      </b-form-input>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6" class="mb-1">
                  <!-- .first_name -->
                  <b-form-group id="input-group-27" :label="$t('students.first_name_en')" label-for="input-27">
                    <b-form-input id="input-27" v-model="newItem.first_name_en" type="text"
                      :placeholder="$t('students.first_name_en')">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6" class="mb-1">
                  <!-- .last_name -->
                  <b-form-group id="input-group-28" :label="$t('students.last_name_en')" label-for="input-28">
                    <b-form-input id="input-28" v-model="newItem.last_name_en" type="text"
                      :placeholder="$t('students.last_name_en')">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6" class="mb-1">
                  <!-- .email -->
                  <b-form-group id="input-group-2" :label="$t('users.email')" label-for="input-2">
                    <validation-provider #default="{ errors }" name="Email" vid="email" rules="required|email">
                      <b-form-input id="input-2" v-model="newItem.email" type="text" :placeholder="$t('users.email')">
                      </b-form-input>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6" class="mb-1">
                  <!-- .mobile -->
                  <b-form-group id="input-group-13" :label="$t('students.mobile')" label-for="input-13">
                    <b-form-input id="input-13" v-model="newItem.mobile" type="number"
                      :placeholder="$t('students.mobile')">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6" class="mb-1">
                  <!-- .email -->
                  <b-form-group :label="$t('users.password')" label-for="reset-password-new">
                    <validation-provider #default="{ errors }" :name="$t('users.password')" vid="Password"
                      rules="required|password">
                      <b-input-group class="input-group-merge" :class="errors.length > 0 ? 'is-invalid' : null">
                        <b-form-input id="reset-password-new" v-model="newItem.password" :type="password1FieldType"
                          :state="errors.length > 0 ? false : null" class="form-control-merge"
                          name="reset-password-new" />
                        <b-input-group-append is-text>
                          <feather-icon class="cursor-pointer" :icon="password1ToggleIcon"
                            @click="togglePassword1Visibility" />
                        </b-input-group-append>
                      </b-input-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6" class="mb-1">
                  <!-- .email -->
                  <b-form-group label-for="reset-password-confirm" :label="$t('users.password_confirmation')">
                    <validation-provider #default="{ errors }" :name="$t('users.password_confirmation')"
                      rules="required|confirmed:Password">
                      <b-input-group class="input-group-merge" :class="errors.length > 0 ? 'is-invalid' : null">
                        <b-form-input id="reset-password-confirm" v-model="newItem.password_confirmation"
                          :type="password2FieldType" class="form-control-merge"
                          :state="errors.length > 0 ? false : null" name="reset-password-confirm" />
                        <b-input-group-append is-text>
                          <feather-icon class="cursor-pointer" :icon="password2ToggleIcon"
                            @click="togglePassword2Visibility" />
                        </b-input-group-append>
                      </b-input-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <!-- .active_status -->

                <b-col md="6" class="mb-1">
                  <!-- .nationality -->
                  <b-form-group id="input-group-29" :label="$t('master.nationalities')" label-for="input-29">
                    <validation-provider #default="{ errors }" name="nationality" vid="nationality" rules="required">
                      <v-select dir="rtl" id="input-30" v-model="newItem.nationality_id" :options="citizenship"
                        :reduce="(country) => country.Code" label="NameAr" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6" class="mb-1">
                  <!-- .country -->

                  <b-form-group id="input-group-30" label="بلد الأقامة" label-for="input-30">
                    <validation-provider #default="{ errors }" name="country" vid="country" rules="required">
                      <v-select dir="rtl" id="input-30" v-model="newItem.country_id" :reduce="(country) => country.Code"
                        label="NameAr" :options="citizenship" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col md="6" class="mb-1">
                  <!-- .birth_date -->
                  <b-form-group id="input-group-33" :label="$t('students.birth_date')" label-for="input-33">
                    <validation-provider #default="{ errors }" name="birth_date" vid="birth_date" rules="required">
                      <date-picker :placeholder="$t('students.birth_date')" v-model="newItem.birth_date" :editable="true"/>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col md="6" class="mb-1">
                  <!-- .gander -->
                  <b-form-group id="input-group-42" :label="$t('students.gander')" label-for="input-42">
                    <b-form-radio v-model="newItem.gender" name="some-radios1" value="male">
                      {{ $t("site.male") }}
                    </b-form-radio>
                    <b-form-radio v-model="newItem.gender" name="some-radios1" value="female">
                      {{ $t("site.female") }}
                    </b-form-radio>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row v-if="register_type == 2">
                <b-col md="6" class="mb-1">

                  <b-form-group id="input-group-424" :label="'الرواية'" label-for="input-424">
                    <b-form-radio v-model="newItem.readingType" name="some-radios2" value="1">
                      رواية حفص
                    </b-form-radio>
                    <b-form-radio v-model="newItem.readingType" name="some-radios2" value="2">
                      رواية ورش
                    </b-form-radio>
                  </b-form-group>

                </b-col>
                <b-col md="6" class="mb1">
                  <b-form-group id="input-group-421" :label="'الجزء'" label-for="input-421">
                    <select v-model="newItem.period" class="form-control mb-2">
                      <option v-for="index in 30" :key="index">{{ index }}</option>
                    </select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row v-if="register_type == 2">
                <b-col md="6" class="mb-1">

                  <b-form-group id="input-group-423" :label="'نوع الحفظ'" label-for="input-423">
                    <b-form-radio v-model="newItem.SaveType" name="some-radios3" value="desc">
                      تصاعدي
                    </b-form-radio>
                    <b-form-radio v-model="newItem.SaveType" name="some-radios3" value="asc">
                      تنازلي
                    </b-form-radio>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-button variant="primary" block :disabled="invalid" @click="register()">
                اشتراك
              </b-button>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <b-link :to="{ name: 'login' }">
              <span>{{ $t("site.do_you_have_an_account") }}</span>

              <!-- <span> سجّل الدخول بدلاً من ذلك</span> -->
            </b-link>
          </p>
        </b-col>
        <b-col v-else-if="register_available == 2 &&  register_type == 1">
          <h2 class="text-center">  {{ $t("site.not_avaialble_register") }}  </h2>
        </b-col>
      </b-col>
      <!-- /Register-->

      <!-- Left Text-->
      <b-col lg="6" class="d-none d-lg-flex align-items-center p-5">
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img fluid :src="imgUrl" alt="Register V2" />
        </div>
      </b-col>
      <!-- /Left Text-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from "vee-validate";

import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
// import CountriesController from "@/Controllers/CountriesController";
// import NationalityController from "@/Controllers/NationalityController";
import vSelect from "vue-select";
import UsersController from "@/Controllers/UsersController";
import MediuEduController from "@/Controllers/MediuEduController";
import Swal from "sweetalert2";
import VueDatetimeJs from "vue-datetime-js";

import Edu_seasonsController from "@/Controllers/Edu_seasonsController";
export default {
  components: {
    // validations
    ValidationProvider,
    ValidationObserver,
    vSelect,
    "date-picker": VueDatetimeJs,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      newItem: { account_type: "student" },
      countryOptions: [],
      nationalityOptions: [],
      edu_seasons_controller : new  Edu_seasonsController(),
      // sideImg: require("@/assets/images/pages/register-v2.svg"),
      sideImg: require("@/assets/images/pages/full-avatar.svg"),

      // validation
      required,
      email,
      citizenship: [],
      // Toggle Password
      password1FieldType: "password",
      password2FieldType: "password",
      quran: 0,
      register_type: 1,
      link_type : 'normal',
      register_available : 3
    };
  },
  async mounted() {
    //get current url
    if(this.$route.params.type && this.$route.params.type == 'quran'){
      this.register_type = 2;
      this.link = 'quran';
    }
    let res = await this.edu_seasons_controller.register_available();
    if(!res.exists){
      this.register_available = 2
    }else{
      this.register_available = 1

    }
  },

  computed: {
    password1ToggleIcon() {
      return this.password1FieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    password2ToggleIcon() {
      return this.password2FieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      if (MAIN_SERVER_URL.serverUrl.includes("furqn")) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require("@/assets/images/pages/register-2.svg");
        return this.sideImg;
      }
      return this.sideImg;
    },
  },
  async created() {
    if (this.$route.params.type == "quran") {
      this.newItem.metaData = "{quran:1}";
      this.newItem.active = 1;
    }
    const ct = new MediuEduController();

    this.citizenship = await ct.GetCitizenship();
  },
  methods: {
    togglePassword1Visibility() {
      this.password1FieldType =
        this.password1FieldType === "password" ? "text" : "password";
    },
    togglePassword2Visibility() {
      this.password2FieldType =
        this.password2FieldType === "password" ? "text" : "password";
    },
    register() {
      this.newItem.register_type = this.register_type;
      if (this.register_type == 2) {
        this.newItem.metaData = "{quran:1}";
        //check for period / readingType / saveType
        if (!this.newItem.period) {
          Swal.fire({
            position: "top-start",
            icon: "error",
            title: "هناك خطأ",
            text: "الرجاء اختيار الجزء",
            showConfirmButton: false,
            timer: 3000,
          });
          return false;
        }
        if (!this.newItem.readingType) {
          Swal.fire({
            position: "top-start",
            icon: "error",
            title: "هناك خطأ",
            text: "الرجاء اختيار الرواية",
            showConfirmButton: false,
            timer: 3000,
          });
          return false;
        }
        if (!this.newItem.SaveType) {
          Swal.fire({
            position: "top-start",
            icon: "error",
            title: "هناك خطأ",
            text: "الرجاء اختيار نوع الحفظ",
            showConfirmButton: false,
            timer: 3000,
          });
          return false;
        }
      }

      this.$refs.registerForm.validate().then(async (success) => {
        if (success) {
          let res = await new UsersController().register(this.newItem);
          console.log(res);
          if (res.status) {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "تمت العملية بنجاح",
              showConfirmButton: false,
              timer: 3000,
            });
            this.$router.push("/");
            return true;
          } else {
            Swal.fire({
              position: "top-start",
              icon: "error",
              title: "هناك خطأ",
              text: Object.values(res.errors)[0][0],
              showConfirmButton: false,
              timer: 3000,
            });
            return false;
          }
          // if(res.)
        }
      });
    },
  },
};
/* eslint-disable global-require */
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
@import "@core/scss/vue/libs/vue-select.scss";

.vpd-icon-btn {
  position: absolute;
  top: 0;
  height: 100%;
  width: 30px;
  display: flex;
  align-items: center;
  right: 0 !important;
  left: inherit !important;
  background: transparent !important;

  svg {
    fill: #ce7b2c;
  }
}

.auth-register-form {
  label {
    margin-bottom: 10px;
  }
}
</style>
